import { render } from "./test3media.vue?vue&type=template&id=1846f6fc"
import script from "./test3media.vue?vue&type=script&lang=js"
export * from "./test3media.vue?vue&type=script&lang=js"

import exportComponent from "D:\\AlterLau\\walter-main\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__